(function(){
  // --- Config ---
  const IST_OFFSET_MIN = 330;               // Asia/Kolkata
  const ORDER_CUTOFF   = { h:18, m:0 };     // 2:00 PM cut-off
  const HANDLING_DAYS  = 1;                 // pick/pack days
  const SUNDAY_OFF     = false;
  const HOLIDAYS       = [];                // e.g., ["2025-10-02"]

  // Prefix rules: 6xxxxx -> 1 days; others -> 3 days
  const TRANSIT_RULES = [
    { match: /^6\d{5}$/, days: 1 },
    { match: /^\d{6}$/,  days: 3 }
  ];

  // --- Helpers (the missing one was toIST) ---
  function toIST(d){ return new Date(d.getTime() + IST_OFFSET_MIN * 60000); }

  function isHoliday(d){
    const y = d.getFullYear();
    const m = String(d.getMonth()+1).padStart(2,'0');
    const day = String(d.getDate()).padStart(2,'0');
    return HOLIDAYS.includes(`${y}-${m}-${day}`);
  }

  function addBizDays(start, days){
    const d = new Date(start);
    let added = 0;
    while (added < days){
      d.setDate(d.getDate() + 1);
      if ((SUNDAY_OFF && d.getDay() === 0) || isHoliday(d)) continue;
      added++;
    }
    return d;
  }

  function formatNice(d){
    return d.toLocaleDateString('en-IN', { weekday:'short', month:'short', day:'numeric' });
  }

  function transitDaysFor(pin){
    for (const r of TRANSIT_RULES){ if (r.match.test(pin)) return r.days; }
    return null;
  }

  // --- Action ---
  function handleCheck(box){
    const elPin = box.querySelector('#hm-pin');
    const elMsg = box.querySelector('#hm-edd-msg');
    if (!elPin || !elMsg) return;

    const pin = (elPin.value || '').trim();
    elMsg.textContent = '';

    if (!/^\d{6}$/.test(pin)){
      elMsg.textContent = 'Please enter a valid 6-digit pincode.';
      return;
    }

    const tDays = transitDaysFor(pin);
    if (tDays == null){
      elMsg.textContent = 'Delivery not available for this pincode.';
      return;
    }

    const nowIST  = toIST(new Date());
    const cutoff  = new Date(nowIST); cutoff.setHours(ORDER_CUTOFF.h, ORDER_CUTOFF.m, 0, 0);

    let startIST = new Date(nowIST);
    if (nowIST > cutoff) startIST = addBizDays(startIST, 1);  // post cut-off -> start next biz day
    startIST = addBizDays(startIST, HANDLING_DAYS);           // handling days
    const etaIST = addBizDays(startIST, tDays);               // transit days
elMsg.innerHTML = `
  ✅ Estimated delivery: <strong>${formatNice(etaIST)}</strong>
  <br>
  <span style="display:inline-block;margin-top:6px;padding:4px 8px;background:#E8F8EC;color:#15803d;border-radius:6px;font-size:13px;font-weight:700;">
    ⚡ Fast 12 hrs Dispatch
  </span>
`;
  }

  // Event delegation (click + Enter)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#hm-check');
    if (!btn) return;
    const box = btn.closest('#hm-edd');
    if (box) handleCheck(box);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const active = document.activeElement;
    if (active && active.id === 'hm-pin'){
      const box = active.closest('#hm-edd');
      if (box) handleCheck(box);
    }
  });

  console.log('HM pincode EDD script loaded');
})();
